import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import { globalStyles } from './utils/theme';

//GLOBAL VARIABLES
window.$company_name = "MYT SoftDev Solutions Inc.";
window.$company_address = "301 The Greenery, Pope John Paul II Avenue, Kasambagan, Cebu City, 6000 Cebu";
window.$company_ceo = "Darmae Maningo Tan";
window.$company_hr = "Laarnie Raga Igot";
window.$company_philhealth_no = "0120-0004-1855";
window.$company_tin = "497-280-919-00000";
window.$company_sss_no = "06-1806478-4";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary:   globalStyles.colorPrimary,
          colorSuccess:   globalStyles.colorSuccess,
          colorWarning:   globalStyles.colorWarning,
          colorTextBase:  globalStyles.colorTextBase,

          fontFamily  :   globalStyles.fontRegular
      }}}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
